module.exports = __webpack_public_path__ + "img/51.b211b781.jpg";